import { Helmet } from "react-helmet-async";
import {  Alert, AlertTitle } from "@mui/material";
import { AuthContext } from "src/contexts/JWTAuthContext";
import { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { messages } from "src/translations/translations";
import { LocalizationContext } from "src/App";
import { FormattedMessage } from "react-intl";
import { getPublicSettings } from "src/api/publicRoutes";
import JwtAdminLoginForm from "./JwtAdminLoginForm";

const JwtAdminLogin = () => {
  const navigate = useNavigate();
  const [emailingEnabled, setEmailingEnabled] = useState(false);
  const [registrationEnabled, setRegistrationEnabled] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [errorLoading, setErrorLoading] = useState(false);
  const { lang } = useParams();
  const { userLanguage, setLanguage } = useContext(LocalizationContext);
  const { uid } = useContext(AuthContext);


  useEffect(() => {
    if (lang !== userLanguage) {
      setLanguage(lang);
    }

    async function fetchSettings() {
      if (uid !== "") {
        navigate("/dashboard");
      }

      const response = await getPublicSettings();
      setErrorLoading(!response.success);
      if (response.success) {
        setEmailingEnabled(response.data.emailing_enabled);
        setRegistrationEnabled(response.data.registration_enabled);
      }
      setIsPageLoading(false);
    }
    fetchSettings();
  }, [uid, lang, setLanguage, navigate, userLanguage]);


  return (
    <>
      <Helmet>
        <title>{messages[lang].greeting}</title>
      </Helmet>
      {isPageLoading ? (
        <div>{messages[lang].loading}</div>
      ) : (
        !errorLoading && (
          <JwtAdminLoginForm
            lang={userLanguage}
            emailingEnabled={emailingEnabled}
            registrationEnabled={registrationEnabled}
          />
        )
      )}
      {errorLoading && (
        <Alert
          severity={"error"}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <AlertTitle sx={{ mt: 0.3 }}>
            <FormattedMessage id="error" />
          </AlertTitle>
        </Alert>
      )}
    </>
  );
};

export default JwtAdminLogin;
